import React from 'react';
import './FlexOfertas.css';
import { CiDiscount1 } from "react-icons/ci";
import { FaBoxOpen } from "react-icons/fa";
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';


const FlexOfertas = () => {
    const navigate = useNavigate()

    const [t] = useTranslation("global")
    const country = process.env.REACT_APP_COUNTRY;

    return (
        <div className="flex-ofertas-container" style={{
            maxWidth: '1500px',
            display: 'flex',
            justifyContent: 'space-around'
        }}>
            <div className="text">
                <h2 style={{ fontWeight: 'bold', color: '#0d1821' }}>{t("ofertas.titulo")}</h2>
                <p style={{ fontWeight: 'bold', color: '#5e6472' }}>{t("ofertas.parrafo-1")}</p>
            </div>

            {country !== "ARG" || country !== "UY" && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className='flex-ofertas-icons selected'>
                    <CiDiscount1 size={'4em'} style={{ marginBottom: '3px' }} color="red" onClick={() => navigate('/ofertas')} />
                    <p style={{ fontWeight: 'bold', color: '#5e6472' }}>{t("ofertas.parrafo-2")}</p>
                    <div className="divider"></div>
                </div>

            )}

            {country !== "UY" && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className='flex-ofertas-icons'>
                <FaBoxOpen size={'4em'} style={{ marginBottom: '3px', }} color="#0077b6" onClick={() => navigate('/openbox')} />
                <p style={{ fontWeight: 'bold', color: '#5e6472', marginBottom: '3px' }}>{t("ofertas.parrafo-3")}</p>
            </div>
        )}
        </div>
    );
};

export default FlexOfertas;